import { BlogRepository } from '../repositories/blog.repository'
import { BlogGetArticleResponse, BlogGetArticlesParams, BlogGetArticlesResponse } from '../types/blog.types'

const blogRepository = new BlogRepository()

export class BlogService {
    async getArticles(params: BlogGetArticlesParams): Promise<BlogGetArticlesResponse> {
        const response = await blogRepository.getArticles(params)
        return response.data
    }

    async getArticle(article_id: number): Promise<BlogGetArticleResponse> {
        const response = await blogRepository.getArticle(article_id)
        return response.data
    }

    async createArticle(payload: FormData): Promise<void> {
        const response = await blogRepository.createArticle(payload)
        return response.data
    }

    async updateArticle(article_id: number, payload: FormData): Promise<void> {
        const response = await blogRepository.updateArticle(article_id, payload)
        return response.data
    }

    async deleteArticle(article_id: number): Promise<void> {
        const response = await blogRepository.deleteArticle(article_id)
        return response.data
    }
}